/**
 * Handles that cannot be claimed because they would shadow internal SPA
 * routes. Mirror of `src/PartyResume.Api/Services/ReservedHandles.cs` —
 * keep both lists in sync.
 *
 * IMPORTANT: When you add a new top-level route in App.js, also add its
 * first path segment here AND in the C# version, otherwise a user with
 * that handle could end up shadowing the new route OR the new route could
 * shadow them.
 */
const RESERVED_HANDLES = new Set([
  // Short Portal links: heyportal.app/p/{code}
  'p',
  // Invite cards: heyportal.app/i/{code}
  'i',
  // A club's / Pro page's contact link: heyportal.app/join/{code}
  'join',
  'domain-connected',
  // Auth + onboarding
  'auth',
  'login',
  'register',
  'signup',
  'signin',
  'logout',
  'forgot-password',
  'reset-password',
  'hi-i-like-to-party',
  'initialize-credential',
  'credential-builder',
  'onboard',
  'party-preference',
  // Dashboards + roles
  'guest',
  'host',
  'admin',
  // Portal house account — hosts all ingested events. Must stay in sync with
  // ReservedHandles.cs and HouseAccountService.Handle.
  'partyresume',
  'curator',
  'pro',
  'pros',
  'offer',
  'embed', // /embed/portal-events.js — the events SDK a Pro page drops on its own site
  // Top-level features
  'events',
  'e',
  'messages',
  'intro',
  'introductions',
  'portal',
  'noir',   // Portal Noir, the club
  'recover-payment',
  'users',
  'wallet',
  'notifications',
  'friends',
  'settings',
  'clubs',
  'gatherings',
  'featured',
  'people',
  'start',
  'signals',
  'portals',  // the broadcast (was 'signals')
  'stories',
  'story',
  'square',
  'calendar',
  'pro',
  'membership',
  'ticket',
  'gt', // a gathering seat's QR: /gt/{code}
  'my-tickets',
  'terms',
  // Reserved profile namespaces / future routes
  'u',
  'user',
  'profile',
  'profiles',
  'search',
  'explore',
  'home',
  'help',
  'about',
  'support',
  'privacy',
  'contact',
  'press',
  'security',
  'faq',
  'blog',
  'jobs',
  'careers',
  // Infra
  'api',
  'www',
  'app',
  'static',
  'assets',
  'brand',
  'uploads',
  'robots.txt',
  'sitemap.xml',
  'favicon.ico',
]);

export function isReservedHandle(handle) {
  if (!handle) return false;
  return RESERVED_HANDLES.has(handle.trim().toLowerCase());
}

export default RESERVED_HANDLES;
